import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import StandardCheckboxField from 'shared/StandardCheckboxField.jsx';
import Submitting from 'shared/Submitting.jsx';

const Restrictions = ({
  pristine,
  submitting,
  handleSubmit,
  onCancel,
  onSubmit,
  requireRosterBeforeCheckout,
  enforceMinimumCaptainAge,
  readOnly
}) => (
  <div>
    <form
      className="animated fadeIn"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="flex center animated fadeIn">
        <div className="col-xs-12 col-lg-10">
          <div className="panel panel-primary">
            <div className="panel-heading">
              <h4 className="panel-title">{'Tournament Restrictions'}</h4>
            </div>
            <div className="panel-body row">
              <div className="col-md-6">
                <div>
                  <Field
                    name="enforceMinimumCaptainAge"
                    component={StandardCheckboxField}
                    label="Enforce a minimum captain age"
                    disabled={readOnly}
                  />
                  { enforceMinimumCaptainAge
                    ? <div>
                        <Field
                          name="minimumCaptainAge"
                          type="number"
                          component={StandardField}
                          step="1"
                          min="0"
                          placeholder="Minimum Captain Age"
                          disabled={readOnly}
                        />
                      </div>
                    : null
                  }
                </div>
                <div>
                  <Field
                    name="showCalculatedDivisionToCaptain"
                    component={StandardCheckboxField}
                    label="Show Calculated Division to Captain"
                    disabled={readOnly}
                  />
                </div>
                <div>
                  <Field
                    name="requireRosterBeforeCheckout"
                    component={StandardCheckboxField}
                    label="Require roster to be filled out before checkout"
                    disabled={readOnly}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <Field
                  name="restrictBowlersToActiveMembership"
                  component={StandardCheckboxField}
                  label="Restrict bowlers to active membership"
                  disabled={readOnly}
                />
                <Field
                  name="restrictBowlersToYouthMembership"
                  component={StandardCheckboxField}
                  label="Restrict bowlers to youth membership"
                  disabled={readOnly}
                />                
                <Field
                  name="blockFailedDivisionCalculation"
                  component={StandardCheckboxField}
                  label="Enforce Divisions when setting rosters"
                  disabled={readOnly || !requireRosterBeforeCheckout}
                />              
              </div>
              <div className="col-md-6">
                <Field
                  name="allowChangeBetweenFreeEvents"
                  component={StandardCheckboxField}
                  label="Allow transfers between free events"
                  disabled={readOnly}
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="enforceMaxEntries"
                  component={StandardCheckboxField}
                  label="Enforce Max Entries"
                  disabled={readOnly}
                /> 
              </div>
              <div className="col-xs-12">
                <Field
                  name="termsUrl"
                  type="text"
                  component={StandardField}
                  placeholder="A link to terms & conditions that will be shown to captains prior to checkout (optional)"
                  label="Terms & Conditions/Rules Link"
                  maxLength="255"
                  disabled={readOnly}
                />
              </div>
              <div className="col-xs-12">
                <hr style={{ marginTop: '10px', borderTopWidth: '3px' }} />
              </div>
              <div className="form-group text-right">
                <div className="col-xs-12">
                  <button
                    type="button"
                    className="btn btn-link"
                    disabled={submitting}
                    onClick={onCancel}
                  >Cancel</button>
                  {` `}
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    disabled={pristine || submitting}
                  >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {`Save`}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
);

Restrictions.propTypes = {
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  enforceMinimumCaptainAge: PropTypes.bool,
  readOnly: PropTypes.bool,
  requireRosterBeforeCheckout: PropTypes.bool,
  restrictBowlersToYouthMembership: PropTypes.bool,
  restrictBowlersToActiveMembership: PropTypes.bool,
  termsUrl: PropTypes.string,
  blockFailedDivisionCalculation: PropTypes.bool
};

export default reduxForm({
  form: 'tournamentRestrictions'
})(Restrictions);



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/Restrictions.jsx